import React from 'react'
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { components } from 'react-select'; // Import components from react-select

// components
import {
  CCol,
  CFormLabel,
} from '@coreui/react-pro'

const FormSelectInput = ({
  id,
  name,
  colSize,
  className,
  inputLabel,
  selectOptions,
  value,
  handleSelectInput,
  handleSearchInput,
  feedbackInvalid,
  invalid,
  disabled,
  isShowLabel = true,
  isShowInvalidErr = true,
  placeholder,
  componentSelect,
  isDetectSearch = false,
  multiple = false,
  isClearable = true,
  onCreateRedirectUrl, // URL to redirect to when 'Create' is clicked
  noOptionsMessageText = 'No Options', // Default message when no options
  createOptionLabel = (inputValue) => `Create "${inputValue}"`, // Function to customize 'Create' label,
  isCreatable = false
}) => {
  // Custom NoOptionsMessage component
  const CustomNoOptionsMessage = (props) => {
    // Only show 'Create' option if onCreateRedirectUrl is provided and there's an input value
    if (onCreateRedirectUrl && props?.selectProps?.inputValue) {
      return (
        <components.NoOptionsMessage {...props}>
          <div className="d-flex justify-content-between align-items-center">
            <span>{noOptionsMessageText}</span>
            <button
              className="btn btn-sm btn-outline-dark"
              onClick={() => window.open(`${onCreateRedirectUrl}?name=${props?.selectProps?.inputValue}`, '_blank')}
              type="button" // Important for buttons inside forms
            >
              {createOptionLabel(props?.selectProps?.inputValue)}
            </button>
          </div>
        </components.NoOptionsMessage>
      );
    }
    return (
      <components.NoOptionsMessage {...props}>
        {noOptionsMessageText}
      </components.NoOptionsMessage>
    );
  };

  return (
    <CCol lg={colSize} className={className}>
      {
        isShowLabel && (
          <CFormLabel>
            {inputLabel}
          </CFormLabel>
        )
      }
      {
        isCreatable ? (
          <CreatableSelect
            id={id}
            name={name}
            isMulti={multiple}
            options={selectOptions}
            className={`${invalid ? 'select-invalid' : ''}`}
            onChange={(e) => handleSelectInput(e)}
            onInputChange={(e) => {
              if (isDetectSearch) {
                handleSearchInput(e)
              }
            }}
            value={value}
            isDisabled={disabled}
            isSearchable={true}
            isClearable={isClearable}
            placeholder={placeholder}
            components={{ ...componentSelect, NoOptionsMessage: CustomNoOptionsMessage }}
          />
        ) : (
          <Select
            id={id}
            name={name}
            isMulti={multiple}
            options={selectOptions}
            className={`${invalid ? 'select-invalid' : ''}`}
            onChange={(e) => handleSelectInput(e)}
            onInputChange={(e) => {
              if (isDetectSearch) {
                handleSearchInput(e)
              }
            }}
            value={value}
            isDisabled={disabled}
            isSearchable={true}
            isClearable={isClearable}
            placeholder={placeholder}
            components={{ ...componentSelect, NoOptionsMessage: CustomNoOptionsMessage }}
          />
        )
      }
      {
        isShowInvalidErr && invalid && (
          <span className='error-text-field'>{feedbackInvalid || feedbackInvalid?.name}</span>
        )
      }
    </CCol>
  )
}

export default FormSelectInput
